import React, { memo } from "react";

import { Box } from "@/components/atoms/Box";
import { Text } from "@/components/atoms/Text";

/**
 * Props interface for SummaryContent view component
 */
interface SummaryContentViewProps {
  testID?: string;
  summaryContent: string;
  isDark: boolean;
}

/**
 * View component for summary content
 *
 * Renders the AI-generated player summary text with appropriate styling based on theme.
 * @param props - Component props
 * @param props.testID - Optional test identifier for testing purposes
 * @param props.summaryContent - The summary text to display
 * @param props.isDark - Whether dark theme is active for color styling
 */
const SummaryContentView = ({
  testID,
  summaryContent,
  isDark,
}: SummaryContentViewProps) => (
  <Box testID={testID}>
    <Text
      variant="body"
      className={`leading-relaxed ${
        isDark ? "text-white" : "text-content-neutral-strong"
      }`}
    >
      {summaryContent}
    </Text>
  </Box>
);

SummaryContentView.displayName = "SummaryContentView";

export default memo(SummaryContentView);
